module.exports = __webpack_public_path__ + "static/West-Midlands-Network-logo-38a4520a26346a7cd5f96ba0b192bbe3.png";